import WVFormatter from '../../../../../../shared/helpers/WVFormatter';

export default (props) => {
  const { record } = props;
  return typeof record.params.amount !== 'undefined' && record.params.amount !== null ? WVFormatter.formatCurrency(record.params.amount) : '';
};
